export class ConnectGcpFolderResponse {
    'gcpFolder';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpFolder",
            "baseName": "gcpFolder",
            "type": "GcpOrganization",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectGcpFolderResponse.attributeTypeMap;
    }
    constructor() {
    }
}
